/** Module slugs (must match user-service seed). */
export const MODULE_WORKSPACE = "workspace";
/** @deprecated Use MODULE_WORKSPACE. Kept for cached navigation during migration. */
export const MODULE_ADMINISTRATION = "administration";
export const MODULE_SITE_MANAGEMENT = "site-management";
export const MODULE_FLEET_MANAGEMENT = "fleet-management";
/** Super-admin only — platform administration and developer tools. */
export const MODULE_SYSTEM = "system";
export const MODULE_CERTIFICATION = "certification";

/** View slugs for route guards / catalog reference. */
export const VIEW_USERS = "users";
export const VIEW_ORGANIZATIONS = "organizations";
export const VIEW_PRODUCTS = "products";
export const VIEW_ALERTS = "alerts";

export const ACTIVE_MODULE_STORAGE_KEY = "lion_pro_active_module_slug";
export const NAVIGATION_CACHE_KEY = "lion_pro_navigation";
